export default "__VITE_ASSET__nwXsmicf__"